import { createSelector } from "reselect";
import { selectPrepJob } from "./selectPrepJob";
import { PrepType } from "@deliverr/prep-service-client";

export const selectHasBarcodingPrep = createSelector(selectPrepJob, (prepJob): boolean => {
  return Boolean(prepJob?.prepTypes?.includes(PrepType.SKU_LABELS));
});
